const CALENDAR_TYPES = [
  'pto',
  'birthdays',
  'work_anniversaries'
];

export default CALENDAR_TYPES;
